/* Below fetchData method reference site - https://github.com/github/fetch */
const BASE_URL =
  process.env.REACT_APP_API_URL || "https://payment.aromathai.com";

export function fetchData(payload, route) {
  const url = BASE_URL + route;
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload || {}),
  })
    .then(async (res) => {
      const text = await res.text(); // read raw body
      // try to parse JSON, otherwise return structured error with raw text
      try {
        const json = text ? JSON.parse(text) : {};
        // normalize to an object that frontend expects
        return json;
      } catch (err) {
        return {
          status: res.status,
          message: text && text.length < 1000 ? text : "Non-JSON response",
          raw: text,
        };
      }
    })
    .catch((err) => {
      return {
        status: 0,
        message: err.message || "Network error",
        rawError: err,
      };
    });
}
